import graphql from 'babel-plugin-relay/macro';
import createMutation from '../../helpers/createMutation';

const mutation = graphql`
  mutation PasswordResetMutation($input: Session__PasswordResetInput!) {
    passwordReset(input: $input) {
      success
    }
  }
`;

const commit = input =>
    createMutation({
        mutation,

        variables: {
            input
        }
    });

export default { commit };
